import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { listUserEndpoints } from '@kirin/api-client/api/endpoints';
import type { EndpointList } from '@kirin/api-client/contracts/endpoints';
import { apiClient } from '@/lib/api-client';

/**
 * KIR-3035: fetch the endpoints (machines) a user has reported in an org, for
 * the Inventory->Users endpoints dialog. Only runs when `enabled` and a userId
 * is present (the dialog is open).
 *
 * KIR-3911: `applyStaleFilter` opts into hiding endpoints beyond the org's
 * inventory-visibility window (the Inventory→Users dialog). The details popover
 * leaves it false so a specific machine still resolves even when it is stale.
 */
export function useUserEndpoints(
  organizationId: string,
  userId: string | null,
  enabled: boolean,
  applyStaleFilter = false
): UseQueryResult<EndpointList> {
  return useQuery({
    queryKey: ['userEndpoints', organizationId, userId, applyStaleFilter],
    queryFn: () =>
      listUserEndpoints(
        apiClient,
        organizationId,
        userId ?? '',
        applyStaleFilter
      ),
    enabled: enabled && !!userId,
    staleTime: 30_000,
  });
}
